import {Stats} from "react-instantsearch-dom";
import React from "react";
import qs from 'qs';


import I18n from "../I18n";

export default () => <Stats
  translations={{
    stats(nbHits, timeSpentMS) {
      let statsDiv = <span><span className="results-num">{nbHits.toLocaleString()}</span> {I18n.stats.results}</span>;

      const routeState = qs.parse(location.search.slice(1));

      if (nbHits || !(routeState.tags || routeState.areas || routeState.category))
        return statsDiv;

      let newRoute = "/";

      if (routeState.query)
        newRoute += "?query=" + routeState.query;

      if (routeState.query)
        return <div>
          {statsDiv}
          <br />
          <br />
          <a className="button is-danger" href={newRoute}>{I18n.filters.clear}</a>
        </div>
    },
  }}
/>
